module.exports = __webpack_public_path__ + "od-ticket-icon/od-ticket-icon-1189819329dd0b6a64053699410bb5f4.svg";